import React from 'react';

const ElectronicSignatureAgreementText = () => (
    <div>
        <h5 className="enrollment-title">Electronic Signature Agreement</h5>
        <p>
            By typing your name below, you are electronically signing this
            Agreement. You agree that your typed name constitutes your legal
            signature and is the equivalent of your manual signature on this
            Agreement.
        </p>
    </div>
);
export { ElectronicSignatureAgreementText };
